const BLACK_LIST = [
  "R"
];

export default BLACK_LIST;